import { useMemo } from 'react';
import { useVendorsQuery } from '@/features/vendor/hooks/useVendorsQuery';

/**
 * D-6: vendorId → vendorName 클라이언트측 해석. be-funding 응답의 vendorName 은 약함
 * ("EVERLINE"→"에버라인" 외엔 raw vendorId echo). BO 의 벤더 목록(useVendorsQuery,
 * /admin/v1/vendors)으로 매핑해 raw id 노출을 근절한다. 펀딩은 거의 EVERLINE 이라
 * 첫 페이지로 충분하나 커버리지 여유로 size 를 키운다.
 */
const VENDOR_MAP_PAGE_SIZE = 100;

export interface VendorNameResolver {
  resolve: (vendorId: string | null | undefined, dtoVendorName?: string | null) => string;
  isLoading: boolean;
}

export const useVendorNameMap = (): VendorNameResolver => {
  const query = useVendorsQuery({ size: VENDOR_MAP_PAGE_SIZE });

  const map = useMemo(() => {
    const m = new Map<string, string>();
    (query.data ?? []).forEach((v) => {
      if (v.vendorId && v.vendorName) m.set(v.vendorId, v.vendorName);
    });
    return m;
  }, [query.data]);

  const resolve = useMemo(
    () =>
      (vendorId: string | null | undefined, dtoVendorName?: string | null): string => {
        if (!vendorId) return dtoVendorName && dtoVendorName.length > 0 ? dtoVendorName : '—';
        const mapped = map.get(vendorId);
        if (mapped) return mapped;
        // 매핑 미스: DTO vendorName 이 id 와 다르면(=실명) 사용, 아니면 id 노출 회피 위해 dash.
        if (dtoVendorName && dtoVendorName.length > 0 && dtoVendorName !== vendorId) {
          return dtoVendorName;
        }
        return '—';
      },
    [map],
  );

  return { resolve, isLoading: query.isPending };
};
